import { action } from "satcheljs";
import type { CalendarReadFormInitializationConfig } from "owa-calendar-helpers-types/lib/CalendarReadFormInitializationConfig";
import type UnifiedTelemetryContext from "owa-calendar-unified-telemetry-utils/lib/types/UnifiedTelemetryContext";
import type { CustomData } from "owa-analytics-types";

export interface LaunchCalendarReadingPaneActionMessage {
    config: CalendarReadFormInitializationConfig;
    targetWindow: Window | undefined;
    freezeDryId: string | undefined;
    popOutClickTime: number | undefined;
    openInNewWindow: boolean | undefined;
    unifiedTelemetryContext?: UnifiedTelemetryContext;
    otherData?: CustomData;
}
export const launchCalendarReadingPane: (config: CalendarReadFormInitializationConfig, targetWindow?: Window, freezeDryId?: string, popOutClickTime?: number, openInNewWindow?: boolean, unifiedTelemetryContext?: UnifiedTelemetryContext, otherData?: CustomData) => LaunchCalendarReadingPaneActionMessage = action("launchCalendarReadingPane", (config: CalendarReadFormInitializationConfig, targetWindow?: Window, freezeDryId?: string, popOutClickTime?: number, openInNewWindow?: boolean, unifiedTelemetryContext?: UnifiedTelemetryContext, otherData?: CustomData): LaunchCalendarReadingPaneActionMessage => ({
    config,
    targetWindow,
    freezeDryId,
    popOutClickTime,
    openInNewWindow,
    unifiedTelemetryContext,
    otherData,
}));
